<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wdyJUz/tc-custom/9780795351563.jpg?1702813300507" alt="This image is the cover for the book Sea and Sardinia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sea and Sardinia
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of <i>Lady Chatterly’s Lover</i>, a travelogue of a journey with his wife that offers a glimpse of post–World War I Europe.</b><br/><br/> After the First World War, when D. H. Lawrence was living in Sicily, he traveled to Sardinia and back in January 1921. This record of what he saw on that journey, <i>Sea and Sardinia</i>, not only reveals his response to new landscapes, new people, and his ability to capture their spirit into literary art, but is also a shrewd inquiry into the post-war values which led to the rise of communism and fascism in various countries around the world. A celebration of the human spirit despite its indictment of materialism, this collection of travel writings has restored passages and corrected corrupted textual readings for the definitive version of the book Lawrence himself called “a marvel of veracity.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        D.H. Lawrence
      </h2>
      
      <p class="authorDescription body article">Born in England on September 11, 1885, D. H. Lawrence is regarded as one of the most influential writers of the twentieth century. Lawrence published many novels and poetry volumes during his lifetime, including Sons and Lovers and Women in Love, but is best known for his infamous novel Lady Chatterley&rsquo;s Lover. The graphic and highly sexual novel was published in Italy in 1928, but was banned in the United States until 1959, and banned in England until 1960. Garnering fame for his novels and short stories early into his career&mdash;especially his collections <I>The Fox, The Captain&rsquo;s Doll, and The Ladybird</I> and <I>The Prussian Officer and Other Stories</I>&mdash;Lawrence later received acclaim for his personal letters and poetry, in which he detailed a range of emotions, from exhilaration to depression to prophetic brooding. He died in France in 1930.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e28a8ba